export default __webpack_public_path__ + "static/media/AFL-Logo_RGB.880816e0.png";